
import { Component, OnInit } from '@angular/core';
import { GlobalClassInstance } from '@commoncore/constants/GlobalClass';
import { TOAST } from '@commoncore/constants/ToastMessages';
import { MemoryController } from '@commoncore/controller/MemoryController';
import { LocalStorageProps } from '@commoncore/enums/localStorageProps';
import { DownloadImplementation } from '@commoncore/implementation/DownloadImplementation';
import { DcgroupcodePickerService } from '@commoncore/services/dcgroupcode-picker.service';
import { GlobalService } from '@commoncore/services/global.service';
import { ActiveRepo } from '@commoncore/services/universal.service';
import { AppEvents, EventsList } from '@commoncore/utils/app-events';
import { ENV_CONSTANTS, environment } from '@env-properties/environment';
import { ENV_CONFIG } from '@env-properties/environment-config';
import { SessionStorageService } from 'angular-web-storage';
@Component({
  standalone:true,
  selector: 'lib-download',
  templateUrl: './download.component.html',
  styleUrls: ['./download.component.scss'],
  imports: []
})
export class DownloadComponent implements OnInit {
  shareAccessService: any;
  cleverTapEventsService:any;
  public downloadImplementation:any;
  itemsCurrentBulkDownload: any;
  downloadModalMaximised: boolean = false;
  localStorageSvc:any;
  universalService:any;
  contextMenuMobileService:any;
  recalculateHeightService:any;
  listService:any;
  localStorageService:any;
  dcGroupCodePicker: any;
  memoriesController: any;
  redirectionService: any;
  route:any;
  constructor(public globalService:GlobalService,public sessionStorage:SessionStorageService) {
    this.setEnvObjects(globalService);
  }

  async ngOnInit(): Promise<void> {
    var classRef = this;
    this.downloadImplementation = DownloadImplementation.getInstance(this.globalService);
    this.downloadImplementation.setHandler(this.globalService);
    AppEvents.globalObservable.subscribe(event => {
      if(event["downloadItems"]){
        classRef.DownloadFile(event["files"]);
      }
      else if(event["downloadZipItem"]){
        classRef.DownloadZipFile(event["files"]);
      } else if(event["closeDownloadProgressBar"]){
        classRef.closeDownload();
      }
    })
  }

  setEnvObjects(globalService){
    this.cleverTapEventsService =  globalService.getCleverTapEventsvc();
    this.localStorageSvc = globalService.getLocalStorageSvcRef();
    this.contextMenuMobileService = globalService.getContextMenuMobileServiceRef();
    this.universalService = globalService.getUniversalServiceRef();
    this.shareAccessService = this.globalService.getShareAccessServiceRef();
    this.recalculateHeightService = this.globalService.getContainerHeightCalculatorService();
    this.listService = globalService.getListServiceRef();
    this.localStorageService = globalService.getLocalStorageSvcRef();
    this.dcGroupCodePicker = DcgroupcodePickerService.getInstance(globalService);
    this.memoriesController = MemoryController.getInstance(this.globalService);
    this.redirectionService = globalService.getRedirectionServiceRef();
    this.route = this.globalService.getActivatedRoute();
  }

  DownloadFile(files) {
    if(window.location.href.includes("shared")) {
      this.cleverTapEventsService.onShareDownloadClick(this.universalService.currentTab);
    }else if(window.location.href.includes("?u")) {
      this.cleverTapEventsService.publicShareDownloadClicked();
    }else if(window.location.href.includes("/memory")) {
      this.cleverTapEventsService.memoryDownloadClicked(this.universalService.currentMemory["spotLightKey"],files[0].objectKey);
      let memoryPayload = {
        "featureCode": "SPT",
        "cardUniqueCode": this.universalService.currentMemory["spotLightKey"],
        "cardActionCode": 'User_SpotlightDownload_Clicked',
        "cardActionData" : {
          "SpotlightId": this.universalService.currentMemory["spotLightKey"],
          "Object Key": files[0].objectKey
        }
      }
      this.memoriesController.sendMemoryAnalytics(memoryPayload);
    }else{
      this.cleverTapEventsService.fileDownloadClicked(this.universalService.currentTab);
    }
    if(this.universalService.showPreview && this.universalService.selectedNodes.length == 0){
      files.push(this.universalService.selectedFile);
    }
    var objects = [];
    
    if (Array.isArray(files)) {
      objects = files;
    } else {
      objects.push(files)
    }
    var url = window.location.href;
    if(url.includes('albums')){
      this.downloadFileForAlbums(objects)
    }else if(this.universalService.activeRepo == ActiveRepo.INVITE){
      this.redirectToSignIn()
    }else{
      this.downloadFiles(objects)
    }
  }
  redirectToSignIn(){
    this.universalService.showPreview = false;
    // this.redirectionService.setRequestedUrlInLocalStorageWithExpiry(LocalStorageProps.INVITE_URL,window.location.href)
    // window.location.href = "/signin";

    const invitekey = this.route.snapshot.queryParamMap.get('c');
    this.redirectionService.setRequestedUrlInLocalStorageWithExpiry(LocalStorageProps.INVITE_URL,window.location.href)
    let url = environment.baseUrl + "/signin" + "/?c=" + invitekey;
    window.location.href = url; // redirect back to invite page after login
  }
  async DownloadZipFile(object){
   // this.downloadFiles(files)
    var  singleFileDownloadUrl = object.url + "&apiKey=" + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] + "&devicetype=web";
    if(window.location.href.includes("privatefolder")){
      await this.listService.getPPFToken();
      singleFileDownloadUrl = singleFileDownloadUrl + "&ppftoken="+encodeURIComponent(this.universalService.header_X_PPF_TOKEN);
    }
    await this.sleep(1000);
      var iframe = document.createElement('iframe')
      iframe.setAttribute("src", singleFileDownloadUrl);
      iframe.setAttribute("style", "visibility:hidden;display:none")
      //iframe.setAttribute("target", "_blank");
      document.body.appendChild(iframe);
      iframe.click();
      setTimeout(()=>{iframe.remove()},60000);
  }

  async downloadFiles(objects){
    var self = this;
    this.universalService.mobileSelectionModeOn = false;
    if(this.universalService.showFileInfo){
      this.universalService.showFileInfo = false;
    }
    if(this.universalService.isMobileDevice){
      this.contextMenuMobileService.decideContextMenuItemsForMobile();
    }
    var singleFileDownloadUrl;
    if(objects.length > ENV_CONSTANTS["constants"]["maxFilesDownloadLimit"]){
      this.universalService.showToast("Please select less than " + ENV_CONSTANTS["constants"]["maxFilesDownloadLimit"] + " items to download.","error");
    } else if ((objects.length > 1) || 
      (objects.length == 1 && (
        (!this.universalService.listView && (objects[0]["objectType"] == "FR" || objects[0]["objectType"] == "BR")) || 
        (this.universalService.listView && !this.universalService.isMobileDevice && objects[0]["FullObject"]!=undefined && (objects[0]["FullObject"]["objectType"] == "FR" || objects[0]["FullObject"]["objectType"] == "BR" ))||  
        (this.universalService.listView && this.universalService.isMobileDevice && (objects[0]["objectType"] == 'FR' || objects[0]["objectType"] == 'BR'))))) { // files>1 and not albumFiles
      var allowDownload = this.calculateSizesBeforeDownload(objects)
      if(!allowDownload){
        let msg = TOAST["MAX_SIZE_DOWNLOAD_LIMIT_REACHED"].replace("__", ""+ENV_CONSTANTS["constants"]["maxBulkDownloadLimit"])
        this.universalService.showToast(msg,"error");
      return;
      }
      this.downloadBulk(objects);
    } else if(objects.length == 1){
      var url = ""
      if (objects[0]["FullObject"]) {
        url = objects[0]["FullObject"]["url"].includes('?') ? objects[0]["FullObject"]["url"] + '&': objects[0]["FullObject"]["url"] + '?';
        singleFileDownloadUrl = url + "apiKey=" + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] + "&devicetype=web&ts=" + new Date().getTime();
      } else {
        url = objects[0]["url"].includes('?') ? objects[0]["url"] + '&': objects[0]["url"] + '?';
        singleFileDownloadUrl = url + "apiKey=" + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] + "&devicetype=web&ts=" + new Date().getTime();
      }
      if(window.location.href.includes("privatefolder")){
        await this.listService.getPPFToken();
        singleFileDownloadUrl = singleFileDownloadUrl + "&ppftoken="+encodeURIComponent(this.universalService.header_X_PPF_TOKEN);
      }
      if(this.universalService.currentTeamFolder){
        this.cleverTapEventsService.tfObjDownload();
      }
      await this.sleep(1000);
      var iframe = document.createElement('iframe')
      iframe.setAttribute("src", singleFileDownloadUrl);
      iframe.setAttribute("style", "visibility:hidden;display:none")
      document.body.appendChild(iframe);
      iframe.click();
      //On download, recent activity should get triggered - 595643 
      if(this.universalService.activeRepo == ActiveRepo.MAIN) {
        setTimeout(()=>{
          AppEvents.emit(EventsList.UPDATE_RECENT);
        },2000);
      }
      setTimeout(()=>{iframe.remove()},60000);
      this.cleverTapEventsService.fileDownloadSuc(this.universalService.currentTab);
    }
  }


  async downloadFileForAlbums(objects){
    var singleFileDownloadUrl = "";
    if (objects.length > 50) { // files > 50 and files are albumFiles
      this.universalService.showToast(TOAST["MAX_FILE_DOWNLOAD_LIMIT_REACHED"],"error")
    } else if (objects.length >= 1 ) { // files>1  and  files are album files  or files is only 1
      if (objects.length > 1 ) {
        this.universalService.showToast(TOAST["FILES_DOWNLOAD_INITIATED"],"success");
        this.universalService.clearSelection();
        this.universalService.selectedNodes= 0;
        this.universalService.mobileSelectionModeOn = false;
      }
      for (var i = 0; i < objects.length; i++) {
        if (objects[i]["FullObject"]) {
          singleFileDownloadUrl = objects[i]["FullObject"]["url"] + "&apiKey=" + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] + "&devicetype=web&ts=" + new Date().getTime();
        } else {
          singleFileDownloadUrl = objects[i]["url"] + "&apiKey=" + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] + "&devicetype=web&ts=" + new Date().getTime();
        }
      await this.sleep(1000);
      var iframe = document.createElement('iframe')
      iframe.setAttribute("src", singleFileDownloadUrl);
      iframe.setAttribute("style", "visibility:hidden;display:none")
      document.body.appendChild(iframe);
      iframe.click();
      setTimeout(()=>{iframe.remove()},60000);
      this.cleverTapEventsService.fileDownloadSuc(this.universalService.currentTab);
      }
    }

  }

  async downloadBulk(objects) {
    var self = this;
    var array = [];
    objects.map(obj=>{
      var completeObject = obj["FullObject"]?obj["FullObject"]["objectKey"]:obj["objectKey"];
      array.push(completeObject);
    })
    //bulk download main repo and shared tab loggedin user
    this.resetValuesBeforeInitiatingBulkDownload();
    let url = "";
    if(window.location.href.includes("sharedwithme")){
      await this.dcGroupCodePicker.decideTypeOfShare(objects[0]["FullObject"]?objects[0]["FullObject"]["shareKey"]:objects[0]["shareKey"])
      url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["downloadURL"] + ENV_CONFIG.commonUrls["bulkDownloadAdvShare"] + '?apiKey=' + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"];
      // url = this.dcGroupCodePicker.updateEndpointBasedOnDCGroupCode(url)
      if(objects[0]["objectKey"] && objects[0]["shareKey"]){
        array = objects.map(obj=> ({"objectKey":obj["objectKey"], "shareKey":obj["shareKey"]}));
      }else{
        array = objects.map(obj=> ({"objectKey":obj["FullObject"]["objectKey"], "shareKey":obj["FullObject"]["shareKey"]}));
      }
    }else if(this.universalService.activeRepo == "share"){
      var dcCode = this.dcGroupCodePicker.getShareDCGroupCode();
      url = ENV_CONSTANTS.multiDCUrls[GlobalClassInstance.ENV_NAME][dcCode]["downloadURL"]+ ENV_CONFIG.commonUrls["bulkDownloadUniversalShare"] + "?shareKey=" + this.shareAccessService.univShareKey + '&apiKey=' + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] + "&vdc=" + dcCode;
      // url = this.dcGroupCodePicker.updateEndpointBasedOnDCGroupCode(url,true);
      array = this.getPayloadForUniversalShareBulkDownload(array);
    } else if(window.location.href.includes('/teamfolder') || this.universalService.searchType == 'teamfolder') {//BDL for TF
      var tfKey = this.universalService.currentTeamFolder["tfKey"];
      url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["downloadURL"] + ENV_CONFIG.commonUrls["teamFolderBulkDownload"] + '?apiKey=' + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"];
      // url = this.dcGroupCodePicker.updateEndpointBasedOnDCGroupCode(url,true)
      array = this.getPayloadForTeamFolderBulkDownload(array, tfKey);
    } else{
      url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["downloadURL"] + ENV_CONFIG.commonUrls["bulkDownloadMainRepo"] + '?apiKey=' + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"],objects[0]["FullObject"]?objects[0]["FullObject"]["shareKey"]:objects[0]["shareKey"];
      // url = this.dcGroupCodePicker.updateEndpointBasedOnDCGroupCode(url,true)
      array = array.map(obj=> ({"objectKey":obj}));
    }
    if(window.location.href.includes("privatefolder")){
      await this.listService.getPPFToken();
      url = url + "&ppftoken="+encodeURIComponent(this.universalService.header_X_PPF_TOKEN);
    }
     this.initiateBulkDownload(url,array)
  }

  resetValuesBeforeInitiatingBulkDownload(){
    this.universalService.downloadInProgress = true;
    this.downloadModalMaximised = false;
    if(document.getElementById("downloadComponent")!=null) {
      document.getElementById("downloadComponent").style.display = 'block';
    }
  }

  initiateBulkDownload(url,array){
    let arrKey = "" + Date.now();
    if(window.location.href.includes('/teamfolder') || this.universalService.searchType == 'teamfolder') {//BDL for TF
      this.itemsCurrentBulkDownload = array.objectKeys.length;
    } else {
      this.itemsCurrentBulkDownload = array.length;
    }
    let msg = "Compressing " + this.itemsCurrentBulkDownload + " item(s)";
    let temp = {key:arrKey, items:array, statusText:msg, cancelDownload:false };
    this.universalService.downloadQueue.push(temp);
    setTimeout(()=>{
      if(document.getElementById("uploadContainer")!=null){
        if(document.getElementById("downloadComponent")!=null) document.getElementById("uploadContainer").style.bottom = ''+document.getElementById("downloadComponent").getBoundingClientRect().height+'px'
        else document.getElementById("uploadContainer").style.bottom = '0'
      }
    })
    if(this.downloadModalMaximised) this.setUploadModalPosition();
    this.downloadImplementation.initiateZipDownload(url,temp, ENV_CONSTANTS["constants"]["maxRetryLimitForBulkDownload"])
  }

  calculateSizesBeforeDownload(downloadObjects){
    var size = 0;
    downloadObjects.map(function (object) {
      var type = object["objectType"]?object["objectType"]:object["FullObject"]["objectType"];
      if (type == "FE" || type == "BE" || type == "DE" || type == "BB" || type =="SE") {
        if(object["sizeInBytes"]){
          size = size + parseInt(object["sizeInBytes"])
          }
          else{
            size = size + parseInt(object["FullObject"]["sizeInBytes"])
          }
      } 
    })
    var GB = (size)/(1024*1024*1024);
    if(GB <= ENV_CONSTANTS["constants"]["maxBulkDownloadLimit"]){
      return 1
    }else{
      return 0
    }
  }

  sleep(milliseconds){
    return new Promise(resolve => setTimeout(resolve, milliseconds));
  }

  getPayloadForUniversalShareBulkDownload(objects){
    var downloadObjects = []
    objects.map(obj=>{
      downloadObjects.push({
        objectKey:obj
      })
    })
    return downloadObjects;
  }

  getPayloadForTeamFolderBulkDownload(objects, tfKey){
    this.cleverTapEventsService.tfObjDownload();
    var payload = [];
    payload.push({
      "objectKeys" : objects,
      "tfKey": tfKey
    });
    return payload[0];
  }

  public minimizeDownloadProgressBar(){
    $("#dwn_list").slideUp('fast',()=>{this.setUploadModalPosition()});
    $("#collapse_btn_dwn").addClass('hidden');
    $("#expand_btn_dwn").removeClass('hidden');
    this.downloadModalMaximised = false;
  }

  public maxmizeDownloadProgressBar(){
    this.downloadModalMaximised = true;
    setTimeout(() => {
      this.setUploadModalPosition();
    }, 10);
   
    // if(document.getElementById("uploadContainer")!=null && document.getElementById("uploadContainer").style.display != 'none'){
    //   // $("#progress_list").slideUp('fast');
    //   // $("#collapse_btn").addClass('hidden');
    //   $("#expand_btn").removeClass('hidden');
    // }
    $("#dwn_list").slideDown('fast',()=>{this.setUploadModalPosition()});
    $("#expand_btn_dwn").addClass('hidden');
    $("#collapse_btn_dwn").removeClass('hidden');  
  }

  public cancelDownload(item){
    var self = this;
    this.universalService.downloadQueue.forEach(e=>{
      if(item.key == e.key){
        e.cancelDownload = true;
        e.statusText = "Download cancelled"
        self.universalService.removeDownloadItemFromList(item)
      }
    })
  }
  
  closeDownload(){
    this.universalService.downloadQueue = [];
    document.getElementById("downloadComponent").style.display = 'none';
    this.setUploadModalPosition();
    if(this.universalService.downloadQueue.length==0) this.universalService.downloadInProgress = false;
    if(this.universalService.isMobileDevice){
      setTimeout(() => {
        this.recalculateHeightService.sendRecalculateEventToComponents(true);
      }, 10);
    }
  }
  setUploadModalPosition(){
    if(document.getElementById("uploadContainer")!=null){
      if(document.getElementById("downloadComponent")!=null) document.getElementById("uploadContainer").style.bottom = ''+document.getElementById("downloadComponent").getBoundingClientRect().height+'px'
      else document.getElementById("uploadContainer").style.bottom = '0'
    }
  }

}
